import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
     .module('surveyCampaignControllers')
     .directive('campaignRespondentCard', directive);

    directive.$inject = ['$http', 'notificationService', 'exportService', 'exportService'];

    function directive($http, notificationService, exportService) {
        return {
            scope: {
                respondent: '=',
                readOnly: '=',
                isMultiSelect: '=',
                isSelectable: '=',
                isStatusLoading: '=',
                canEditRespondent: '=',
                isExternalRespondent: '=',
                surveyv2ReportContext: '=',
                layoutRatio: '=?',
                toRemoveRespondent: '&',
                toSendReminder: '&',
                toUnlockCompletion: '&',
                toEditRespondent: '&?'
            },
            restrict: 'AE',
            templateUrl: require('./campaignRespondentCard.tpl.html'),
            controller: ['$scope', '$stateParams', function ($scope, $stateParams) {

              // Poll export
                $scope.pollExport = function (report) {
                  exportService.pollExport(report.apiUrl, {
                    reportType: report.ReportType,
                    reportPath: report.ReportPath
                  });
                };

                // Show or hide actions
                $scope.showOrHideActions = function ($event) {
                    if ($scope.readOnly || $scope.isMultiSelect) return;
                    $scope.displayActions = !$scope.displayActions;
                    $event.stopPropagation();
                };

                // Remove backup system owner
                $scope.removeRespondent = function () {
                    $scope.toRemoveRespondent().then(function () {
                        $scope.isRemovedRespondent = true;
                    });
                };

                // Unlock completion for respondent
                $scope.unlockCompletion = function () {
                    $scope.toUnlockCompletion().then(function () { });
                };


                // Send reminder to respondent
                $scope.sendReminderToRespondent = function () {
                    if ($scope.respondent.isSendingInvitation) {
                        return;
                    }
                    $scope.respondent.isSendingInvitation = true;

                    $scope.toSendReminder()
                          .then(function () {
                        notificationService.notify('The respondent should receive an invitation soon');
                    }).finally(function () {
                        $scope.respondent.isSendingInvitation = false;
                    });
                };

                // Toggle Selection
                $scope.toggleSelection = function ($event) {
                    $scope.respondent.isSelected = !$scope.respondent.isSelected;
                    $event.stopPropagation();
                };

                // Edit respondent
                $scope.editRespondent = function () {
                    $scope.toEditRespondent();
                };
            }],
            link: function (scope, el, attrs) {
                scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                    column: 'col-sm-12'
                };
                // Display or not actions
                scope.displayActions = false;
                scope.isRemovedRespondent = false;

                scope.$watch('surveyv2ReportContext+ODDCampaignRespondentID', function () {
                    if (_.isUndefined(scope.surveyv2ReportContext)) return;
                    if (_.isUndefined(scope.surveyv2ReportContext.ODDBusinessUnitID)) return;
                    if (_.isUndefined(scope.surveyv2ReportContext.ReportParams)) return;

                    var reportsToShow = [{
                        ParamKey: 'NonAnonymizedWord'
                    }];

                    var reportsParams = _.cloneDeep(scope.surveyv2ReportContext.ReportParams);
                    var reportsToShow = _.intersectionBy(reportsParams,
                                                         reportsToShow,
                                                        'ParamKey');

                    var buId = scope.surveyv2ReportContext.ODDBusinessUnitID;
                    var campId = scope.respondent.ODDCampaignID;
                    var respId = scope.respondent.ODDCampaignRespondentID;
                    var reportApiBaseUrl = environment.apiUrl + '/ReportPilot/API/SurveyV2/BusinessUnit/' + buId +
                                           '/Campaign/' + campId +
                                            '/CR/' + respId +
                                            '/Export/To/';

                    scope.surveyV2Reports = _.map(reportsToShow, function (report) {
                      report.apiUrl = reportApiBaseUrl + report.ReportFormat;

                      switch (report.ReportFormat) {
                        case 'DOCX':
                          report.ReportCssIcon = 'fa fa-file-word-o';
                          break;
                        case 'XLSX':
                          report.ReportCssIcon = 'fa fa-file-excel-o';
                          break;
                      }
                        return report;
                    });
                });
            }
        };
    }
})();
